module.exports = __webpack_public_path__ + "img/24.950d1c17.jpg";